module.exports = __webpack_public_path__ + "static/media/Meghan1.378fca36.tif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spoon/Meghan1.tif
// module id = 129
// module chunks = 0